<template>
    <div class="custom-text-wrapper">
        <input 
            id="fileUpload" 
            ref="dataFile" 
            type="file" 
            @change="handleFileUpload($event)" 
            hidden 
        />
        
        <div v-if="isiFile" class="file-label">
            <i class="fas fa-file mr-1"></i>
            <span>{{ isiFile }}</span>
            <button type="button" class="file-remove" @click="clearFile">
                <i class="fas fa-times"></i>
            </button>
        </div>
        
        <div class="input-container">
            <div class="input-wrapper">
                <button 
                    id="plus" 
                    type="button" 
                    class="action-btn attach-btn"
                    @click="chooseFiles()"
                    title="Attach file"
                >
                    <i class="fas fa-paperclip"></i>
                </button>
                
                <emoji-picker @emoji="append" :search="search">
                    <div 
                        slot="emoji-invoker" 
                        slot-scope="{ events: { click: clickEvent } }"
                        @click.stop="clickEvent"
                        class="action-btn emoji-btn"
                        title="Add emoji"
                    >
                        <svg height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path
                                d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" />
                        </svg>
                    </div>
                    <div slot="emoji-picker" slot-scope="{ emojis, insert }">
                        <div class="emoji-picker" :style="position">
                            <div class="emoji-picker__search">
                                <input type="text" v-model="search" v-focus placeholder="Search emoji...">
                            </div>
                            <div class="emoji-picker__content">
                                <div v-for="(emojiGroup, category) in emojis" :key="category">
                                    <h5>{{ category }}</h5>
                                    <div class="emojis">
                                        <span 
                                            v-for="(emoji, emojiName) in emojiGroup" 
                                            :key="emojiName" 
                                            @click="insert(emoji)"
                                            :title="emojiName"
                                        >
                                            {{ emoji }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </emoji-picker>
                
                <input 
                    ref="input" 
                    v-on:keyup.enter="kirimPesan" 
                    v-model="input" 
                    @input="$emit('input', $event.target.value)" 
                    class="message-input"
                    placeholder="Type your message..."
                    type="text"
                />
            </div>
            
            <button 
                v-on:click="kirimPesan" 
                type="button"
                class="send-btn"
                :disabled="!input.trim() && !file"
                title="Send message"
            >
                <i class="fas fa-paper-plane"></i>
            </button>
        </div>
    </div>
</template>

<script>
    import EmojiPicker from 'vue-emoji-picker'

    export default {
        components: {
            EmojiPicker,
        },
        props: ['value', 'pos'],
		
        data() {
            return {
                input: "",
                search: '',
                position: "top:-330px",
				ada:false,
				isiFile:'',
				file:''
            }
        },
        mounted() {
            if(this.pos == "bottom"){
                this.position = "right:10px;top:40px"
            }
        },
        watch: {
            value: {
                handler(v){
                    this.input = v;
                },
                deep: true
            }
        },
        methods: {
            append(emoji) {
                this.input += emoji
                this.$refs.input.focus()
                this.$emit('input', this.input)
            },
			kirimPesan(){
				if (!this.input.trim() && !this.file) return;
				this.isiFile=''
				this.file=''
				this.$refs.dataFile.value = ''
				this.$parent.sendMessage()	
			},
			clearFile() {
				this.isiFile = '';
				this.file = '';
				this.$refs.dataFile.value = '';
				this.$emit('updateFile', null);
			},
			chooseFiles() {
				document.getElementById("fileUpload").click()
			},
			handleFileUpload( event ){
				const file = event.target.files[0];
				if (!file) return;
				
				this.file = file;
				this.ada = true;
				this.isiFile = file.name;
				
				this.$emit('updateFile', this.file);
			},
        },
        directives: {
            focus: {
                inserted(el) {
                    el.focus()
                },
            },
        },
    };
</script>

<style scoped>
    .custom-text-wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .file-label {
        display: flex;
        align-items: center;
        padding: 6px 12px;
        background: #f0f9ff;
        border: 1px solid #bae6fd;
        border-radius: 8px;
        font-size: 0.75rem;
        color: #0369a1;
        gap: 8px;
    }

    .file-label i.fa-file {
        color: #0284c7;
    }

    .file-label span {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .file-remove {
        background: transparent;
        border: none;
        color: #0369a1;
        cursor: pointer;
        padding: 2px 6px;
        border-radius: 4px;
        transition: all 0.2s;
        font-size: 0.75rem;
    }

    .file-remove:hover {
        background: #bae6fd;
        color: #0c4a6e;
    }

    .input-container {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
    }

    .input-wrapper {
        flex: 1;
        display: flex;
        align-items: center;
        background: #f9fafb;
        border: 1px solid #e5e7eb;
        border-radius: 24px;
        padding: 4px 8px;
        transition: all 0.2s;
        min-height: 44px;
    }

    .input-wrapper:focus-within {
        background: #ffffff;
        border-color: #4f46e5;
        box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
    }

    .action-btn {
        background: transparent;
        border: none;
        color: #6b7280;
        cursor: pointer;
        padding: 8px;
        border-radius: 50%;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 36px;
        min-height: 36px;
        flex-shrink: 0;
    }

    .action-btn:hover {
        background: #e5e7eb;
        color: #4f46e5;
        transform: scale(1.05);
    }

    .action-btn:active {
        transform: scale(0.95);
    }

    .attach-btn i {
        font-size: 0.875rem;
    }

    .emoji-btn {
        padding: 6px;
    }

    .emoji-btn svg {
        fill: #6b7280;
        transition: fill 0.2s;
    }

    .emoji-btn:hover svg {
        fill: #4f46e5;
    }

    .message-input {
        flex: 1;
        border: none;
        background: transparent;
        outline: none;
        padding: 8px 12px;
        font-size: 0.875rem;
        color: #1f2937;
        min-width: 0;
    }

    .message-input::placeholder {
        color: #9ca3af;
    }

    .send-btn {
        background: #4f46e5;
        border: none;
        color: white;
        cursor: pointer;
        padding: 0;
        border-radius: 50%;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
        flex-shrink: 0;
        box-shadow: 0 2px 4px rgba(79, 70, 229, 0.2);
    }

    .send-btn:hover:not(:disabled) {
        background: #4338ca;
        transform: scale(1.05);
        box-shadow: 0 4px 8px rgba(79, 70, 229, 0.3);
    }

    .send-btn:active:not(:disabled) {
        transform: scale(0.95);
    }

    .send-btn:disabled {
        background: #d1d5db;
        cursor: not-allowed;
        box-shadow: none;
        opacity: 0.6;
    }

    .send-btn i {
        font-size: 0.875rem;
    }

    /* Emoji Picker Styles */
    .emoji-picker {
        position: absolute;
        z-index: 1000;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        border: 1px solid #e5e7eb;
        width: 320px;
        max-height: 360px;
        overflow: hidden;
        padding: 0;
        box-sizing: border-box;
        border-radius: 12px;
        background: #ffffff;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
    }

    .emoji-picker__search {
        padding: 12px;
        border-bottom: 1px solid #e5e7eb;
        background: #f9fafb;
    }

    .emoji-picker__search input {
        width: 100%;
        border-radius: 8px;
        border: 1px solid #e5e7eb;
        padding: 8px 12px;
        outline: none;
        font-size: 0.875rem;
        background: white;
        transition: border-color 0.2s;
    }

    .emoji-picker__search input:focus {
        border-color: #4f46e5;
        box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
    }

    .emoji-picker__content {
        overflow-y: auto;
        max-height: 300px;
        padding: 8px;
    }

    .emoji-picker__content::-webkit-scrollbar {
        width: 6px;
    }

    .emoji-picker__content::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }

    .emoji-picker__content::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 10px;
    }

    .emoji-picker__content::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
    }

    .emoji-picker h5 {
        margin: 12px 0 8px 0;
        color: #6b7280;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 600;
        cursor: default;
        padding: 0 4px;
    }

    .emoji-picker .emojis {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    }

    .emoji-picker .emojis span {
        padding: 6px;
        cursor: pointer;
        border-radius: 6px;
        font-size: 1.25rem;
        transition: all 0.15s;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 32px;
        min-height: 32px;
    }

    .emoji-picker .emojis span:hover {
        background: #f3f4f6;
        transform: scale(1.1);
    }

    .emoji-picker .emojis span:active {
        transform: scale(0.95);
    }

    /* Responsive */
    @media (max-width: 768px) {
        .input-wrapper {
            min-height: 40px;
        }

        .send-btn {
            width: 40px;
            height: 40px;
        }

        .action-btn {
            min-width: 32px;
            min-height: 32px;
            padding: 6px;
        }

        .emoji-picker {
            width: 280px;
            max-height: 320px;
        }
    }
</style>
